module.exports = __webpack_public_path__ + "img/logo.a2ea2ad4.png";